export default '/build/120bf855.svg'